import React from 'react'
import moment from 'moment-timezone'

import CancelBooking from 'components/CancelBooking'
import RecurrenceCancellationPenalty from './components/RecurrenceCancellationPenalty'
import { formatDate, pluralizedWeekday } from 'utils/dates'
import { TIMEZONE } from '@src/globals'

class CancelRecurrence extends CancelBooking {
  constructor (props) {
    super(props)

    this.bookingName = 'recurrencia'
  }

  getWeekdaysNames (recurrence) {
    const weekdays = {
      'monday': {
        index: 0,
        name: 'Lunes'
      },
      'tuesday': {
        index: 1,
        name: 'Martes'
      },
      'wednesday': {
        index: 2,
        name: 'Miércoles'
      },
      'thursday': {
        index: 3,
        name: 'Jueves'
      },
      'friday': {
        index: 4,
        name: 'Viernes'
      },
      'saturday': {
        index: 5,
        name: 'Sábado'
      },
      'sunday': {
        index: 6,
        name: 'Domingo'
      }
    }

    const recurrenceWeekdays = recurrence.weekdays

    return (
      recurrenceWeekdays
        .map(weekday => weekdays[weekday])
        .sort((a, b) => a.index - b.index)
        .map(weekday => weekday.name)
        .map(weekday => weekday.toLowerCase())
    )
  }

  renderPenalty (props) {
    const {
      bookingId,
      onPenaltyFetched
    } = props

    return (
      <RecurrenceCancellationPenalty
        recurrenceId={bookingId}
        onPenaltyFetched={onPenaltyFetched}
      />
    )
  }

  renderInfo ({ booking }) {
    const recurrenceMoment = moment.tz(Date.now(), TIMEZONE).day(booking.weekday).hour(booking.hour).minute(0)
    const recurrenceTime = formatDate('h:mm A', recurrenceMoment)

    const recurrenceDays = booking.weekdays
                            ? this.getWeekdaysNames(booking).join(', ')
                            : pluralizedWeekday(recurrenceMoment)

    return (
      <p>
        Estás a punto de cancelar tu recurrencia de los <b>{recurrenceDays} a las {recurrenceTime}</b>
      </p>
    )
  }
}

export default CancelRecurrence



// WEBPACK FOOTER //
// ./src/screens/App/screens/Recurrences/screens/CancelRecurrence/CancelRecurrence.js